import React from "react";
import { IconButton, TableCell, Typography } from "@material-ui/core";
import DeleteIcon from "@mui/icons-material/Delete";
import AtColorPalette from "../../../../components/AtColorPalette/AtColorPalette";
import { withTranslation } from 'react-i18next';

function ThresholdItem({
    id,
    limite,
    color,
    deleteLimite,
    disabled,
    t,
}) {
    return (
        <>
            <TableCell>{t('thresholdConfig.table.header.limit')}</TableCell>
            <TableCell>
                <Typography variant="body1">{limite} %</Typography>
            </TableCell>
            <TableCell>{t('thresholdConfig.table.header.color')}</TableCell>
            <TableCell>
                <AtColorPalette
                    value={color}
                    onChange={() => {}}
                    colors={[]}
                    style={{
                        width: 25,
                        height: 25,
                        borderRadius: 5,
                    }}
                    disabled={disabled}
                />
            </TableCell>
            <TableCell>
                <IconButton
                    disabled={!Boolean(deleteLimite)}
                    onClick={() => {
                        if (deleteLimite) {
                            deleteLimite(id);
                        }
                    }}
                >
                    <DeleteIcon color={Boolean(deleteLimite) ? "error" : "inherit"} />
                </IconButton>
            </TableCell>
        </>
    );
}

export default withTranslation()(ThresholdItem);
